module.exports = __webpack_public_path__ + "img/Left.0fa75d09.png";